export default __webpack_public_path__ + "static/media/trail-mobile.43772257.svg";